import { render, staticRenderFns } from "./NewPaymentsFilter.vue?vue&type=template&id=40e6d854&scoped=true"
import script from "./NewPaymentsFilter.vue?vue&type=script&lang=js"
export * from "./NewPaymentsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e6d854",
  null
  
)

export default component.exports